/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ConditionDTO,
    ConditionDTOFromJSON,
    ConditionDTOFromJSONTyped,
    ConditionDTOToJSON,
} from './ConditionDTO';

/**
 * 
 * @export
 * @interface MissingPrivilege
 */
export interface MissingPrivilege {
    /**
     * 
     * @type {string}
     * @memberof MissingPrivilege
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof MissingPrivilege
     */
    action?: MissingPrivilegeActionEnum;
    /**
     * 
     * @type {Array<ConditionDTO>}
     * @memberof MissingPrivilege
     */
    conditions?: Array<ConditionDTO>;
}

/**
* @export
* @enum {string}
*/
export enum MissingPrivilegeActionEnum {
    Read = 'READ',
    Write = 'WRITE',
    Deny = 'DENY'
}

export function MissingPrivilegeFromJSON(json: any): MissingPrivilege {
    return MissingPrivilegeFromJSONTyped(json, false);
}

export function MissingPrivilegeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MissingPrivilege {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'action': !exists(json, 'action') ? undefined : json['action'],
        'conditions': !exists(json, 'conditions') ? undefined : ((json['conditions'] as Array<any>).map(ConditionDTOFromJSON)),
    };
}

export function MissingPrivilegeToJSON(value?: MissingPrivilege | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'action': value.action,
        'conditions': value.conditions === undefined ? undefined : ((value.conditions as Array<any>).map(ConditionDTOToJSON)),
    };
}

